
import { authHeader } from '../helpers/authHeader';
import "react-toastify/dist/ReactToastify.css";
import apiClient from '../helpers/apiClient';



export const transactionService = {
    getTransactionInvoice,
    getTransactionPayment,
    getRetainerInvoice,
    getSalesOrder,
    getPackage,
    getBill,
    getCreditNote,
    getMasterData,
    getSalesOrderByData
};



  function getMasterData(){ 
   return  apiClient.get(`/transactions-master-data`, authHeader())
  }


  function getTransactionInvoice(customer_id){
  return  apiClient.get(`/get-transaction-invoice/${customer_id}`, authHeader())}


  function getTransactionPayment(customer_id){
  return  apiClient.get(`get-transaction-payment/${customer_id}`, authHeader())

  }
  


  function getRetainerInvoice(customer_id){
   return  apiClient.get(`/get-transaction-retainer/${customer_id}`, authHeader())
  }

  function getSalesOrder(customer_id){
   return apiClient.get(`/get-transaction-sales-order/${customer_id}`, authHeader())

  }

  function getSalesOrderByData(customer_id,data){
   return apiClient.post(`/get-transaction-sales-order/${customer_id}`, data, authHeader())

  }

  function getPackage(customer_id){
   return apiClient.get(`/get-transaction-package/${customer_id}`, authHeader());

  }


  function getBill(customer_id){
     return apiClient.get(`/get-transaction-bill/${customer_id}`, authHeader())
  }


  function getCreditNote(customer_id){
   return apiClient.get(`/get-transaction-credit-note/${customer_id}`, authHeader())
  }



